import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-detect-type',
  imports: [CommonModule, RouterModule],
  templateUrl: './detect-type.component.html',
  styleUrl: './detect-type.component.scss',
})
export class DetectTypeComponent {
  type: any;
  constructor(private router: Router) {}
  types: any[] = [
    {
      name: 'Join as a User (Client)',
      type: 'user',
      desc: 'Post projects, find top freelancers, and get your work done with ease',
      img: 'assets/images/user-icon.svg',
    },
    {
      name: 'Join as a Service provider (Freelancer)',
      type: 'freelancer',
      desc: 'Showcase your skills, build a portfolio, and get hired by clients worldwide',
      img: 'assets/images/freelancer-icon.svg',
    },
  ];

  selectType(item: any) {
    this.type = item.type;
  }
  routerToRegister() {
    if (this.type) {
      this.router.navigate(['/auth/signup', this.type]);
    }
  }
}
